export const environment = {
	production: true,
	kenticoRoot: 'https://deliver.kontent.ai/dccf8f08-27ba-001f-5f51-2c972188f3d7',
	kenticoToken: '',
	defaultDonationUrl: 'https://secured.hillsdale.edu/hillsdale/support-online-courses/',
	kontent: {
		deliveryProjectId: 'dccf8f08-27ba-001f-5f51-2c972188f3d7',
		previewApiKey: 'ew0KICAiYWxnIjogIkhTMjU2IiwNCiAgInR5cCI6ICJKV1QiDQp9.ew0KICAianRpIjogIjRjZjY3ODRhNDI1NDRkYTZiNjFkZWQ5ZDI0Yjk0OWI3IiwNCiAgImlhdCI6ICIxNTg0ODExMDc2IiwNCiAgImV4cCI6ICIxOTMwNDExMDc2IiwNCiAgInByb2plY3RfaWQiOiAiZGNjZjhmMDgyN2JhMDAxZjVmNTEyYzk3MjE4OGYzZDciLA0KICAidmVyIjogIjEuMC4wIiwNCiAgImF1ZCI6ICJwcmV2aWV3LmRlbGl2ZXIua2VudGljb2Nsb3VkLmNvbSINCn0.WxU136FErZBLXmI_x_ERDNDLv3VIx7eldQFyX03IJHQ',
		usePreviewMode: false,
	}
};
